export const MIGRATION_TYPE_PRIMARY = "primary"; // (migrate the current design that the user owns)
export const MIGRATION_TYPE_BACKUP = "backup"; // (migrate a design backup of the current design)
export const MIGRATION_TYPE_SHARED = "shared"; // (migrate a shared design)
export const MIGRATION_TYPE_PREVIEW = "preview"; // (preview a migration)

export const DATA_MODEL_VERSION_OVERRIDE = "dataModelVersionOverride";
